import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import couponIcon from "../../../assets/coupon1.png"

const CouponSection = ({
  comboCart,
  fullObjectRewardCart,
  removebtnflag,
  fetchCouponsList,
  setShowCoupoListFlag,
}) => {
  const guestId = localStorage.getItem("Guest_clientId");
  const appliedCoupon = fullObjectRewardCart&&fullObjectRewardCart?.data?.reward?.couponName
  const reward=fullObjectRewardCart&&fullObjectRewardCart?.data?.reward
  // Hide coupon section if comboCart exists
  if (comboCart) return null;

  const isCouponApplied = Boolean(appliedCoupon);

  const getSavedAmountText = () => {
    if (!fullObjectRewardCart) return "";
    const amount =
      reward?.type === "freegift"
        ? reward?.amount
        : reward?.count;
    const unit =
      reward?.type === "cashback" || reward?.type === "freegift"
        ? "rupees on this order"
        : "on your final bill";

    return (
      <>
        You saved{" "}
        <Typography
          component="span"
          sx={{ fontWeight: 700, color: "#384F6F", fontSize: "13px" }}
        >
          ₹{amount}
        </Typography>{" "}
        {unit}
      </>
    );
  };

  return (
    <>
      {!guestId && (
        <>
          {!isCouponApplied ? (
            // ================= NO COUPON APPLIED =================
            <Card
              elevation={2}
              sx={{
                borderRadius: "10px",
                background:
                  "linear-gradient(0deg, rgba(250,225,75,0.16), rgba(250,225,75,0.16)), #fff",
                height: 63,
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center">
                    <img
                      src={couponIcon}
                      alt="coupon"
                      style={{ width: 20, height: 20 }}
                    />
                    <Typography
                      variant="subtitle1"
                      sx={{ ml: 1, fontSize: "16px", color: "#384F6F" }}
                    >
                      Apply Coupon:
                    </Typography>
                  </Box>
                  <Typography
                    component="span"
                    sx={{
                      color: "#00B177",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={fetchCouponsList}
                  >
                    Select Coupon
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ) : (
            // ================= COUPON APPLIED =================
            <Card
              elevation={2}
              sx={{
                borderRadius: "10px",
                background:
                  "linear-gradient(0deg, rgba(250,225,75,0.16), rgba(250,225,75,0.16)), #fff",
              }}
            >
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box display="flex" alignItems="center">
                    <img
                      src={couponIcon}
                      alt="coupon"
                      style={{ width: 20, height: 20 }}
                    />
                    <Typography
                      variant="subtitle1"
                      sx={{ ml: 1, fontSize: "3.5vw", color: "#384F6F" }}
                    >
                      Applied Coupon:
                      <Typography
                        component="span"
                        sx={{
                          color: "#00B177",
                          fontWeight: 600,
                          textTransform: "uppercase",
                          ml: 0.5,
                          fontSize: "3.2vw",
                        }}
                      >
                        {appliedCoupon}
                      </Typography>
                    </Typography>
                  </Box>

                  {removebtnflag && (
                    <Button
                      variant="text"
                      color="error"
                      size="small"
                      sx={{ textTransform: "none", fontSize: 14 }}
                      onClick={() => fetchCouponsList()}
                    >
                      Remove
                    </Button>
                  )}
                </Box>

                <Typography
                  variant="body2"
                  sx={{ mt: 0.5, ml: 3, fontSize: 13, color: "#64748B" }}
                >
                  {getSavedAmountText()}
                </Typography>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default CouponSection;
